import { DocsAnalyticsTimeFrame } from "./SDKDocsAnalyticsTimeFrame";
export class DocsAnalyticsVisitHeatMapWeek {
    constructor(model) {
        this.timeFrame = new DocsAnalyticsTimeFrame(model.timeFrame);
        this.mon = model.mon;
        this.tue = model.tue;
        this.wed = model.wed;
        this.thu = model.thu;
        this.fri = model.fri;
        this.sat = model.sat;
        this.sun = model.sun;
    }
}
